import React from 'react';

import { useLocation } from "react-router-dom";

function Navbar() {
  const location = useLocation();

  // Helper function for handling navigation
  const handleNavClick = (e, path, scrollIndex) => {
    e.preventDefault();

    if (location.pathname === path) {
      // Same page - perform scrolling
      const targetElement = document.querySelector(`[data-scroll-index="${scrollIndex}"]`);
      if (targetElement) {
        const offsetTop = targetElement.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: offsetTop, behavior: 'smooth' });
      } else {
        console.warn(`Target element with data-scroll-index="${scrollIndex}" not found.`);
      }
    } else {
      // Different page - navigate to the specified route
      window.location.href = path; // Use React Router navigation if applicable
    }
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg nav-crev">
        <div className="container">
          <a className="logo icon-img-100" href="/">
            <img src="/light/assets/imgs/logo-light.png" alt="logo" />
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="icon-bar">
              <i className="fas fa-bars"></i>
            </span>
          </button>

          <div
            className="collapse navbar-collapse justify-content-center"
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav">
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="/light/home-startup-onepage"
                  onClick={(e) => handleNavClick(e, "/light/home-startup-onepage", 0)}
                >
                  <span className="rolling-text">Home</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="/light/page-services"
                  onClick={(e) => handleNavClick(e, "/light/page-services", 1)}
                >
                  <span className="rolling-text">Services</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="/light/page-about3"
                  onClick={(e) => handleNavClick(e, "/light/page-about3", 2)}
                >
                  <span className="rolling-text">About</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="/light/page-team"
                  onClick={(e) => handleNavClick(e, "/light/page-team", 3)}
                >
                  <span className="rolling-text">Team</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="/light/page-team"
                  onClick={(e) => handleNavClick(e, "/light/page-FAQS", 4)}
                >
                  <span className="rolling-text">FAQS</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="/light/page-contact"
                  onClick={(e) => handleNavClick(e, "/light/page-contact", 5)}
                >
                  <span className="rolling-text">Contact</span>
                </a>
              </li>
            </ul>
          </div>

          <div className="topnav">
            <div className="menu-icon cursor-pointer">
              <span className="icon ti-align-right"></span>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;

